import { render, staticRenderFns } from "./UserGroupForm.vue?vue&type=template&id=dcd6eb14&scoped=true"
import script from "./UserGroupForm.vue?vue&type=script&lang=js"
export * from "./UserGroupForm.vue?vue&type=script&lang=js"
import style0 from "./UserGroupForm.vue?vue&type=style&index=0&id=dcd6eb14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd6eb14",
  null
  
)

export default component.exports